// Global 3rd party plugins
import { activateSentry } from "@/core/services/sentry.service";
import { createApp, Component } from "vue";
import { PerfectScrollbarPlugin } from "vue3-perfect-scrollbar";
import { Router } from "vue-router";
import InlineSvgPlugin from "vue-inline-svg";
// @ts-ignore Types does not exist for vue-instantsearch...
import InstantSearch from "vue-instantsearch/vue3/es";
import pinia from "@/core/store/piniaSetup";
import Treeselect from "@zanmato/vue3-treeselect";
// @ts-ignore
import VueTelInput from "vue-tel-input";
import Vue3Toastify from "vue3-toastify";

// Vue 3rd party plugins
import i18n from "@/core/composables/vue-i18n";
import vueTelInputConfig from "@/core/plugins/VueTelInput";

// 3rd party styles
import "@zanmato/vue3-treeselect/dist/vue3-treeselect.min.css";
import "bootstrap";
import "vue3-perfect-scrollbar/style.css";
import "vue-tel-input/vue-tel-input.css";
import "vue3-toastify/dist/index.css";
import "@/designSystem/style/_toastify-override.scss";

export default (router: Router, mainVueComponent: Component) => {
  const app = createApp(mainVueComponent);

  activateSentry(router, app);

  app
    .component("InlineSvg", InlineSvgPlugin)
    .component("treeselect", Treeselect)
    .use(i18n)
    .use(pinia)
    .use(router)
    .use(InstantSearch)
    .use(PerfectScrollbarPlugin)
    .use(VueTelInput, vueTelInputConfig)
    .use(Vue3Toastify)
    .mount("#circularx");
};
